import { Component, OnInit } from '@angular/core';
import { FacilityType } from '../../_models/facility-type.model';
import { AdminService } from '../../_services/admin.service';
import { MatSnackBar } from '@angular/material';

import {
    trigger,
    state,
    style,
    animate,
    transition
} from '@angular/animations';

@Component({
    selector: 'app-facility-types',
    templateUrl: './facility-types.component.html',
    styleUrls: ['./facility-types.component.less'],
    animations: [
        trigger('sidebar', [
            state('void', style({ transform: 'translateX(100%)' })),
            transition(':enter', animate('150ms ease-in', style({ transform: 'translateX(0)' }))),
            transition(':leave', animate('200ms ease-out', style({ transform: 'translateX(100%)' })))
        ])
    ]
})
export class FacilityTypesComponent implements OnInit {

    private busy: boolean = false;
    private sidebarBusy: boolean = false;

    private items: FacilityType[];
    private sortColumn: string = 'Title';
    private sortAscending: boolean = true;
    private selectedItem: FacilityType = null;
    private newItem: FacilityType = null;
    private deleteMode: boolean = false;

    constructor(private adminService: AdminService, private snackBar: MatSnackBar) { }

    ngOnInit() {
        this.loadItems();
    }

    loadItems() {
        this.busy = true;
        this.sidebarBusy = true;
        return this.adminService.get('ports/facilities/types')
            .subscribe((response) => {
                let result = response.json().Result;
                this.items = result.FacilityTypes;
                this.items.sort(this.sortFunction.bind(this));
                this.busy = false;
                this.sidebarBusy = false;
            }, (response) => {
                this.snackBar.open("An error occurred loading the facility types.", null, { duration: 3000 });
                this.busy = false;
                this.sidebarBusy = false;
            });
    }

    select(item: any) {
        if (this.selectedItem == item) return;

        this.cancelNewItem();
        this.selectedItem = { ...item };
    }

    deselect() {
        this.selectedItem = null;
        this.deleteMode = false;
    }

    editExistingItem() {
        if (this.sidebarBusy) return;

        this.sidebarBusy = true;
        this.adminService.update('ports/facilities/types', this.selectedItem)
            .subscribe((response) => {
                let result = response.json().Result;
                let updatedITem = result.FacilityType;
                let existingItem = this.items.find((item) => item.Id == updatedITem.Id);
                existingItem.Title = updatedITem.Title;

                this.items.sort(this.sortFunction.bind(this));

                this.selectedItem = null;
                this.sidebarBusy = false;

                this.snackBar.open('Facility type was successfully updated.', null, { duration: 2000 });
            }, (response) => {
                let error = response.json();

                this.selectedItem = null;
                this.sidebarBusy = false;

                this.snackBar.open(error.Message, null, { duration: 3000 });
            });
    }

    delete() {
        this.deleteMode = true;
    }

    deleteExistingItem() {
        if (this.sidebarBusy) return;

        this.sidebarBusy = true;
        this.adminService.delete('ports/facilities/types', this.selectedItem)
            .subscribe((response) => {
                this.items = this.items.filter((item) => item.Id != this.selectedItem.Id);
                this.items.sort(this.sortFunction.bind(this));

                this.selectedItem = null;
                this.sidebarBusy = false;

                this.snackBar.open('Facility type was successfully deleted.', null, { duration: 2000 });
            }, (response) => {
                let error = response.json();

                this.selectedItem = null;
                this.sidebarBusy = false;

                this.snackBar.open(error.Message, null, { duration: 3000 });
            });
    }

    startNewItem() {
        this.deselect();
        this.newItem = new FacilityType();
    }

    cancelNewItem() {
        this.newItem = null;
    }

    addNewItem() {
        if (this.sidebarBusy) return;

        this.sidebarBusy = true;
        this.adminService.add('ports/facilities/types', this.newItem)
            .subscribe((response) => {
                let result = response.json().Result;
                let id = result.Id;

                let createdItem = { ...this.newItem };
                createdItem.Id = id;
                this.items.push(createdItem);

                this.items.sort(this.sortFunction.bind(this));

                this.newItem = null;
                this.sidebarBusy = false;

                this.snackBar.open('Facility type was successfully added.', null, { duration: 2000 });
            }, (response) => {
                let error = response.json();

                this.newItem = null;
                this.sidebarBusy = false;

                this.snackBar.open(error.Message, null, { duration: 3000 });
            });
    }

    sort(column: string) {
        if (this.sortColumn == column) {
            this.sortAscending = !this.sortAscending;
            this.items.sort(this.sortFunction.bind(this));

            return;
        }

        this.sortColumn = column;
        this.sortAscending = true;
        this.items.sort(this.sortFunction.bind(this));
    }

    private sortFunction(left, right): number {
        let leftVal = left[this.sortColumn].toUpperCase();
        let rightVal = right[this.sortColumn].toUpperCase();

        if (this.sortAscending) {
            return leftVal < rightVal ? -1 : 1;
        }

        return leftVal > rightVal ? -1 : 1;
    }
}



// WEBPACK FOOTER //
// ./Angular/app/admin/facility-types/facility-types.component.ts